import React from 'react';
import {
  Box,
  Button,
  Text,
  ButtonAppearance,
  Modal,
  ModalClose,
  ModalBody,
  ModalFooter,
  ModalSize,
} from '@bechtel/gds';
import { ModalHeaderStyled, ModalSubHeader } from '@bechtel/client-common';
import { t, Trans } from '@lingui/macro';

export const WorkpackageScheduleError = ({ onClose }) => {
  return (
    <Modal visible closable onDismiss={onClose} size={ModalSize.LARGE}>
      <ModalHeaderStyled title={t`Error`}>
        <ModalClose onClick={onClose}></ModalClose>
      </ModalHeaderStyled>
      <ModalSubHeader>
        <Text family="graphik" size="500" color="grey.1000" weight="600">
          <Trans>Update Workpackage Schedule Error</Trans>
        </Text>
      </ModalSubHeader>
      <ModalBody>
        <Box flexDirection={{ sm: 'column' }} px={{ sm: '500' }} py={{ sm: '600' }}>
          <Text family="graphik">
            <Trans>There was an error updating workpackage schedule.</Trans>
          </Text>
          <Text family="graphik">
            <Trans>Please try again later.</Trans>
          </Text>
        </Box>
      </ModalBody>
      <ModalFooter>
        <Box justifyContent={{ sm: 'flex-end' }}>
          <Box mr={{ sm: '400' }}>
            <Button appearance={ButtonAppearance.SECONDARY} onClick={onClose}>
              <Trans>Close</Trans>
            </Button>
          </Box>
        </Box>
      </ModalFooter>
    </Modal>
  );
};
